import React from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const { RangePicker } = DatePicker;
const disabledDate = (current) => {
  // Can not select days before today
  return current > dayjs().startOf('day');
};

const DateRangePicker = ({ fromDate, toDate, onFromDateChange, onToDateChange }) => {
  const handleDateChange = (dates) => {
    if (dates) {
      const [start, end] = dates;

      // Pass the UTC formatted date to the parent component
      onFromDateChange(dayjs(start).startOf("day").utc().format("YYYY-MM-DDTHH:mm:ss[Z]"));
      onToDateChange(dayjs(end).endOf("day").utc().format("YYYY-MM-DDTHH:mm:ss[Z]"));
    } else {
      onFromDateChange(null);
      onToDateChange(null);
    }
  };

  return (
    <RangePicker
      value={[
        fromDate ? dayjs(fromDate) : null,
        toDate ? dayjs(toDate) : null,
      ]}
      onChange={handleDateChange}
      format="DD-MM-YYYY"
      allowClear={true}
      disabledDate={disabledDate}
    />
  );
};

export default DateRangePicker;
